import MmenuLight from 'mmenu-light';

const mainMenu = document.querySelector('#menu .is-active');
if (mainMenu) {
  //console.log(mainMenu);
  const hasChildren = mainMenu.closest('.has-children');
  if (hasChildren) {
    //console.log(hasChildren);
    hasChildren.classList.add('is-active');
  }
}

const menu = new MmenuLight(
  document.querySelector('#menu'),
  '(max-width: 1023px)',
);

menu.navigation({
  title: '',
});

const drawer = menu.offcanvas({
  position: 'right',
});

document.addEventListener('click', (e) => {
  const target = e.target.closest('.open-menu');
  if (!target) return;

  if (!document.body.classList.contains('mm-ocd-opened')) {
    drawer.open();
  } else {
    drawer.close();
  }
});
